import { apiGet, apiPost } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";

export default {
  // Upgrade subscription plan
  upgradeSubscription: (payload) => apiPost(domainUrl('/v1/subscription/upgrade'), payload),

  // Downgrade subscription plan
  downgradeSubscription: (payload) => apiPost(domainUrl('/v1/subscription/downgrade'), payload),

  // Cancel subscription
  cancelSubscription: () => apiPost(domainUrl('/v1/subscription/cancel')),

  // Get subscription invoices
  getSubscriptionInvoices: () => apiGet(domainUrl('/v1/subscription/invoices')),

  // Check license limit
  checkLicenseLimit: () => apiGet(domainUrl('/v1/subscription/license')),

  // Get subscription details
  getSubscriptionDetails: () => apiGet(domainUrl('/v1/subscription/details')),
};
